import { MenuItem, SvgIcon } from '@mui/material';
import { FunctionComponent } from 'react';

import Icons from '@Constants/Icons.constants';

import { StyledMenu } from './PopOverMenu.styles';
import { PopOverMenuProps } from './PopOverMenu.types';

const PopOverMenu: FunctionComponent<PopOverMenuProps> = (
  props: PopOverMenuProps
): JSX.Element => {
  const { menuItems, onClose, ...resProps } = props;
  return (
    <StyledMenu onClose={onClose} {...resProps}>
      {menuItems.map(
        (
          { icon, label, value, disabled, onClick },
          index: number
        ): JSX.Element => (
          <MenuItem
            key={`menuItem-${index}`}
            disabled={disabled}
            id={value}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              if (onClick) {
                onClick(e);
              }
              if (onClose) {
                onClose(e, 'backdropClick');
              }
            }}
          >
            {icon && <SvgIcon>{Icons[icon]}</SvgIcon>}
            {label}
          </MenuItem>
        )
      )}
    </StyledMenu>
  );
};

export default PopOverMenu;
